/** @module                         Hooks */

import { useState }                 from "react";

import { useTranslation }           from "react-i18next";

/** @module                         Components */

import Fieldset                     from "../Global/Forms/Fieldset";

import { LabeledInput }             from "../Global/Forms/Inputs_Spread";

import Checkbox                     from "../Global/Forms/Checkbox";

const

/**
 *
 * @param { Object } props
 *
 * @returns bank accounts list component
 *
 */

BankAccountsList = ( { bankAccounts = [], onChange } ) => { const

    { t } = useTranslation (),

    [ editingId, setEditingId ] = useState ( null ),

    [ showAddForm, setShowAddForm ] = useState ( false ),

    [ formState, setFormState ] = useState ( {

        iban: "",

        bankName: "",

        swiftCode: "",

        isEnabled: true,

        isDefault: false

    } ),

    /**
     *
     * @param { Object } e
     *
     * @event handleChange
     *
     */

    handleChange = e => { const { name, value, type, checked } = e.target;

        if ( type === "checkbox" ) return setFormState ( prev => ( { ...prev, [ name ]: checked } ) );

        setFormState ( prev => ( { ...prev, [ name ]: value } ) );

    },

    /**
     *
     * @event handleAdd
     *
     */

    handleAdd = () => {

        if ( ! formState.iban || ! formState.bankName ) return;

        const newAccount = {

            iban: formState.iban,

            bankName: formState.bankName,

            swiftCode: formState.swiftCode,

            isEnabled: formState.isEnabled,

            isDefault: formState.isDefault

        };

        const updatedAccounts = [ ...bankAccounts, newAccount ];

        if ( onChange ) onChange ( updatedAccounts );

        setFormState ( {

            iban: "",

            bankName: "",

            swiftCode: "",

            isEnabled: true,

            isDefault: false

        } );

        setShowAddForm ( false );

    },

    /**
     *
     * @param { Object } account
     *
     * @event handleEdit
     *
     */

    handleEdit = account => {

        setEditingId ( account.id );

        setFormState ( {

            iban: account.iban,

            bankName: account.bankName,

            swiftCode: account.swiftCode || "",

            isEnabled: account.isEnabled,

            isDefault: account.isDefault

        } );

    },

    /**
     *
     * @event handleUpdate
     *
     */

    handleUpdate = () => {

        if ( ! formState.iban || ! formState.bankName ) return;

        const updatedAccounts = bankAccounts.map ( account =>

            account.id === editingId

                ? { ...account, ...formState }

                : account

        );

        if ( onChange ) onChange ( updatedAccounts );

        setEditingId ( null );

        setFormState ( {

            iban: "",

            bankName: "",

            swiftCode: "",

            isEnabled: true,

            isDefault: false

        } );

    },

    /**
     *
     * @event handleCancel
     *
     */

    handleCancel = () => {

        setEditingId ( null );

        setShowAddForm ( false );

        setFormState ( {

            iban: "",

            bankName: "",

            swiftCode: "",

            isEnabled: true,

            isDefault: false

        } );

    },

    /**
     *
     * @param { String } id
     *
     * @event handleDelete
     *
     */

    handleDelete = id => {

        if ( ! window.confirm ( t ( "are_you_sure" ) ) ) return;

        const updatedAccounts = bankAccounts.map ( account =>

            account.id === id

                ? { ...account, _destroy: true }

                : account

        );

        if ( onChange ) onChange ( updatedAccounts );

    },

    /**
     *
     * @param { Number } index
     * @param { String } field
     *
     * @event handleToggle
     *
     */

    handleToggle = ( index, field ) => {

        const updatedAccounts = bankAccounts.map ( ( account, idx ) => {

            // Find the account by index
            if ( idx === index ) {

                const newValue = ! account[ field ];

                // If toggling isDefault to true, we'll handle unsetting others below
                return { ...account, [ field ]: newValue };

            }

            // If setting another account as default, unset this one
            if ( field === "isDefault" && idx !== index ) {

                return { ...account, isDefault: false };

            }

            return account;

        } );

        if ( onChange ) onChange ( updatedAccounts );

    };

    /** @returns */

    return (

        <Fieldset legend={ t ( "bank_accounts" ) }>

            <div style={ { marginBottom: "20px" } }>

                { bankAccounts && bankAccounts.filter ( a => ! a._destroy ).length > 0 ? (

                    <table style={ { width: "100%", borderCollapse: "collapse" } }>

                        <thead>

                            <tr style={ { borderBottom: "2px solid #ddd" } }>

                                <th style={ { padding: "10px", textAlign: "left" } }>{ t ( "bank_name" ) }</th>

                                <th style={ { padding: "10px", textAlign: "left" } }>IBAN</th>

                                <th style={ { padding: "10px", textAlign: "left" } }>SWIFT</th>

                                <th style={ { padding: "10px", textAlign: "center" } }>{ t ( "enabled" ) }</th>

                                <th style={ { padding: "10px", textAlign: "center" } }>{ t ( "default" ) }</th>

                                <th style={ { padding: "10px", textAlign: "center" } }>{ t ( "actions" ) }</th>

                            </tr>

                        </thead>

                        <tbody>

                            { bankAccounts.filter ( a => ! a._destroy ).map ( ( account, index ) => (

                                editingId === ( account.id || index ) ? (

                                    <tr key={ account.id || index } style={ { borderBottom: "1px solid #eee" } }>

                                        <td style={ { padding: "10px" } }>

                                            <input

                                                type="text"

                                                name="bankName"

                                                value={ formState.bankName }

                                                onChange={ handleChange }

                                                style={ { width: "100%" } }

                                            />

                                        </td>

                                        <td style={ { padding: "10px" } }>

                                            <input

                                                type="text"

                                                name="iban"

                                                value={ formState.iban }

                                                onChange={ handleChange }

                                                style={ { width: "100%" } }

                                            />

                                        </td>

                                        <td style={ { padding: "10px" } }>

                                            <input

                                                type="text"

                                                name="swiftCode"

                                                value={ formState.swiftCode }

                                                onChange={ handleChange }

                                                style={ { width: "100%" } }

                                            />

                                        </td>

                                        <td style={ { padding: "10px", textAlign: "center" } }>

                                            <input

                                                type="checkbox"

                                                name="isEnabled"

                                                checked={ formState.isEnabled }

                                                onChange={ handleChange }

                                            />

                                        </td>

                                        <td style={ { padding: "10px", textAlign: "center" } }>

                                            <input

                                                type="checkbox"

                                                name="isDefault"

                                                checked={ formState.isDefault }

                                                onChange={ handleChange }

                                            />

                                        </td>

                                        <td style={ { padding: "10px", textAlign: "center" } }>

                                            <button

                                                type="button"

                                                onClick={ handleUpdate }

                                                className="button add"

                                                style={ { marginRight: "5px" } }

                                            >

                                                { t ( "save" ) }

                                            </button>

                                            <button

                                                type="button"

                                                onClick={ handleCancel }

                                                className="button"

                                            >

                                                { t ( "cancel" ) }

                                            </button>

                                        </td>

                                    </tr>

                                ) : (

                                    <tr key={ account.id || index } style={ { borderBottom: "1px solid #eee" } }>

                                        <td style={ { padding: "10px" } }>{ account.bankName }</td>

                                        <td style={ { padding: "10px" } }>{ account.iban }</td>

                                        <td style={ { padding: "10px" } }>{ account.swiftCode || "-" }</td>

                                        <td style={ { padding: "10px", textAlign: "center" } }>

                                            <input

                                                type="checkbox"

                                                checked={ account.isEnabled || false }

                                                onChange={ () => handleToggle ( index, "isEnabled" ) }

                                            />

                                        </td>

                                        <td style={ { padding: "10px", textAlign: "center" } }>

                                            <input

                                                type="checkbox"

                                                checked={ account.isDefault || false }

                                                onChange={ () => handleToggle ( index, "isDefault" ) }

                                            />

                                        </td>

                                        <td style={ { padding: "10px", textAlign: "center" } }>

                                            <button

                                                type="button"

                                                onClick={ () => handleEdit ( account ) }

                                                className="button"

                                                style={ { marginRight: "5px" } }

                                            >

                                                { t ( "edit" ) }

                                            </button>

                                            <button

                                                type="button"

                                                onClick={ () => handleDelete ( account.id || index ) }

                                                className="button remove"

                                            >

                                                { t ( "delete" ) }

                                            </button>

                                        </td>

                                    </tr>

                                )

                            ) ) }

                        </tbody>

                    </table>

                ) : (

                    <p>{ t ( "no_bank_accounts" ) }</p>

                ) }

            </div>

            { showAddForm ? (

                <div style={ { padding: "15px" } }>

                    <h4>{ t ( "add_bank_account" ) }</h4>

                    <LabeledInput

                        label={ t ( "bank_name" ) }

                        value={ formState.bankName }

                        action={ handleChange }

                        name="bankName"

                    />

                    <LabeledInput

                        label="IBAN"

                        value={ formState.iban }

                        action={ handleChange }

                        name="iban"

                    />

                    <LabeledInput

                        label="SWIFT/BIC"

                        value={ formState.swiftCode }

                        action={ handleChange }

                        name="swiftCode"

                    />

                    <Checkbox

                        id="isEnabled"

                        text={ t ( "enabled" ) }

                        state={ formState.isEnabled }

                        action={ handleChange }

                    />

                    <Checkbox

                        id="isDefault"

                        text={ t ( "default" ) }

                        state={ formState.isDefault }

                        action={ handleChange }

                    />

                    <div style={ { marginTop: "10px" } }>

                        <button

                            type="button"

                            onClick={ handleAdd }

                            className="button add"

                            style={ { marginRight: "10px" } }

                        >

                            { t ( "add" ) }

                        </button>

                        <button

                            type="button"

                            onClick={ handleCancel }

                            className="button"

                        >

                            { t ( "cancel" ) }

                        </button>

                    </div>

                </div>

            ) : (

                <button

                    type="button"

                    onClick={ () => setShowAddForm ( true ) }

                    className="button add"

                >

                    { t ( "add_bank_account" ) }

                </button>

            ) }

        </Fieldset>

    );

}

/** @exports BankAccountsList */

export default BankAccountsList;
